import Vue from "vue";
import Router from "vue-router";
import Base from "@/student/layouts/Base";
import Store from "./store/store"
Vue.use(Router);
import StudentHome from "./pages/home/Home"
import PageNotFound from "@/common/components/PageNotFound.vue";
import ShowCycle from "@/student/pages/cycle/ShowCycle";
import SelectModule from "@/student/pages/module/SelectModule";
import CalendarPage from "@/student/pages/calendar/Index";
import MetricsIndexPage from "@/student/pages/metric/Index";
import { selectModulesRouteName, studyNowRouteName, calendarRouteName, homeRouteName, showModuleRouteName } from "./constants/routes";
import Login from "@/common/pages/Login.vue";


import startSessionRequests from "./utils/startSessionRequests.js";
import ShowModule from "./pages/module/ShowModulePage.vue";

const router = new Router({
    mode: "history",
    routes: [
      {
        path: "/",
        redirect: '/aluno'
      },
      {
        path: "/admin/login",
        component: Login,
        name: 'login',
      },
      {
        path: "/aluno",
        component: Base,
        children: [
            {
                path: "/",
                component: StudentHome,
                name: homeRouteName,
            },
            {
                path: "modulo/:module_id",
                component: ShowModule,
                name: showModuleRouteName,
            },
            {
                path: "relatorios",
                component: MetricsIndexPage,
                name: "student.metric.index",
            },
            {
                path: "ciclo/",
                component: ShowCycle,
                name: studyNowRouteName,
            },
            {
                path: "modulos/selecionar",
                component: SelectModule,
                name: selectModulesRouteName,

                // beforeEnter(to, from, next) {
                //     const selectedCycle = Store.getters.selectedCycle
                //     const current_cycle = Store.getters.current_cycle;
                //     const modules_current_cycle = Store.state.cycle.current.modules;

                //     if (modules_current_cycle.length || moment(current_cycle.end).isBefore()) {
                //       next({ name: 'student.cycle.show' });
                //     } else {
                //       next();
                //     }
                // }
            },
            {
                path: "calendario/",
                component: CalendarPage,
                name: calendarRouteName,
            },
            {
                path: "*",
                component: PageNotFound,
            },

        ]
    }, ],
});

router.beforeEach((to, from, next) => {

    /*AO ENTRAR NA ROTA SE O USUÁRIO NÃO ESTIVER SETADO TENTA PEGAR O USUÁRIO LOGADO*/
    if (!Store.state.auth.user && to.name != 'login') {
        Store.dispatch('isLoading');
        startSessionRequests()
            .then(() => {
                next();
            })
            .catch(() => {
              next({name:'login'});
            })
            .finally(() => Store.dispatch( 'isLoading', false ));
    } else {
        next();
    }
});

export default router;
